/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 * Import
 * - Components
 */
import ToolTip from '../../../common/ToolTip/ToolTip'
import { Alert } from '../../../common/Alert/Alert'
import { currency, symbol } from '../../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import '../styles/VariationsDropdown.css'

/**
 * Class for the dropdown items inside every row
 *
 * @export
 * @class ClientsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class ClientsRowQuotes extends React.Component<any, any> {
    render() {
        return (
            <div
                className="clientVariations"
            >
                <div className="clientVariations__row">
                    {
                        (this.props.subjectivity) ?
                            <Alert type="warning">
                                <p>
                                    <span>Subjectivity Warning:</span> These quotes are subject to certain terms if
                                    they are to become a policy.
                                </p>
                            </Alert> :
                            null
                    }
                    <div className="clientVariations__row__title">
                        <div />
                        <div />
                        <div>Quote ref no.</div>
                        <div>Excess</div>
                        <div>Commission</div>
                        <div>Premium</div>
                        <div>Actions</div>
                    </div>
                    {
                        (this.props.variations.map((variation: any, i: number) => (
                            <div className="clientVariations__row__content" key={variation.id}>
                                <div>Quote {variation.id}</div>
                                <div className="clientVariations__row__content__icon">
                                    <ToolTip
                                        position="left"
                                        verticalPosition="top"
                                        onMouseEnter={() => this.props.noOverflow(true)}
                                        onMouseLeave={() => this.props.noOverflow(false)}
                                    >
                                        <div className="operative_section_text">
                                            Operative sections
                                        </div>
                                        {variation.operativeSections.map((operativeSection, index) => (
                                            '- ' + operativeSection.charAt(0).toUpperCase()
                                            + operativeSection.slice(1) + '\n'
                                        ))}
                                    </ToolTip>
                                </div>
                                <div>{variation.quoteRef}</div>
                                <div>{symbol()} {variation.excess}</div>
                                <div>{variation.commission}%</div>
                                <div>{currency(variation.premium)}</div>
                                <div onClick={() => this.props.bindClick(this.props.quote, variation)}>
                                    BIND
                                </div>
                            </div>
                        )))
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/VariationsDropdown.tsx